import React from "react"

import TasksView_Column from "../../../../../../model2/column/column"
import {
    AggregateFunctionType
} from "../../../../../../data-structures/aggregators/types"
import AggregateShellComponent from "../../../../../../gd-modules/common/aggregate/aggregate-shell"

type Props = {
    column                      : TasksView_Column
    value                       : any

    isFirstInBlock?             : boolean
    isLastInBlock?              : boolean

    onChangeAggregateFunction   : {(aggregateFunction: AggregateFunctionType): void}
}

// const debug = "FieldToggle_AggregateCell"
const debug = false

export default function FieldToggle_AggregateCell(props: Props) {

    // props.value is from FieldAggregatorChecked.aggregate()
    const isValid = !_.isNil(props.value?.countAll) && !_.isNaN(props.value?.countAll)

    const valueLabel = isValid ? '{0}/{1}'.f(props.value?.countChecked, props.value?.countAll) : ''

    // Get available aggregate function options for this field, if any
    const options = props.column.field?.getAggregateOptions()

    debug && console.log(debug, 'render', valueLabel, props.value)

    return (
        <AggregateShellComponent
            options                     = {options}
            noData                      = {!isValid}
            hint                        = {valueLabel}
            aggregateFunction           = {props.column.aggregateFunction as string}
            isFirstInBlock              = {!!props.isFirstInBlock}
            isLastInBlock               = {!!props.isLastInBlock}
            onChangeAggregateFunction   = {props.onChangeAggregateFunction}
        >
            {isValid &&
                <div className="aggregate-value aggregate-number">
                    {valueLabel}
                </div>}
        </AggregateShellComponent>
    )
}
